/*
 Create by MRQ  2015-12-23
 */
"use strict";
angular.module("sysManageMentSensitiveWordModule", ["sysMgrSensitiveWordCtrlModule"])
    .controller("sysManageMentSensitiveWordCtrl", ["$scope", "$timeout", "$stateParams", '$modal', "trsHttpService", 'modalDialog', 'trsspliceString', function($scope, $timeout, $stateParams, $modal, trsHttpService, modalDialog, trsspliceString) {
        initStatus();
        initData();

        //初始化状态
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20
            };
            $scope.copyCurrPage = 1;
            $scope.params = {
                "serviceid": "mlf_websiteconfig",
                "methodname": "querySensitiveWords",
                "CurrPage": $scope.page.CURRPAGE,
                "PageSize": $scope.page.PAGESIZE,
                "selectAll": false
            };
            $scope.selectedArray = [];
            $scope.status = {
                batchOperateBtn: {
                    "hoverStatus": "",
                    "clickStatus": ""
                },
                testBoolean: false
            }

        }
        //初始化数据
        function initData() {
            requestData();
        }

        //数据请求函数
        function requestData(callback) {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                if (angular.isFunction(callback)) {
                    callback(data);
                } else {
                    $scope.items = data.DATA;
                    $scope.page = data.PAGER;
                    angular.isDefined($scope.page) ? $scope.page.PAGESIZE =
                        $scope.page.PAGESIZE.toString() : $scope.page = {
                            "PAGESIZE": 0,
                            "ITEMCOUNT": 0,
                            "PAGECOUNT": 0
                        };
                }
                $scope.selectedArray = [];
            });
        }
        //快捷按钮点击
        $scope.quickTab = function(type) {
            $timeout(function() {
                $scope.$root.$broadcast("quickTabChoose", type);
            }, 100);
        };

        //下一页
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        /*跳转指定页面*/
        $scope.jumpToPage = function() {
            if ($scope.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.CurrPage = $scope.copyCurrPage;
            requestData();
        };
        $scope.selectPageNum = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.params.PageSize = $scope.page.PAGESIZE;
            $scope.copyCurrPage = 1;
            requestData();

        };
        //全选
        $scope.selectAll = function() {
            $scope.selectedArray = $scope.selectedArray.length == $scope.items.length ? [] : []
                .concat($scope.items);
            $scope.params.selectAll = $scope.selectedArray.length == 0 ? false : true;
        };
        //单选
        $scope.selectDoc = function(item) {
            if ($scope.selectedArray.indexOf(item) < 0) {
                $scope.selectedArray.push(item);
            } else {
                $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
            }
        };
        //添加弹窗
        $scope.addViews = function() {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/sensitive_add_tpl.html",
                windowClass: 'productManageMent-sensitive-add',
                backdrop: false,
                controller: "sensitiveAddCtrl"
            });
            return modalInstance.result.then(function(result) {
                addSensitive(result);
            });
        };
        $scope.modifyViews = function(item) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/sensitive_modify_tpl.html",
                windowClass: 'productManageMent-sensitive-modify',
                backdrop: false,
                controller: "sensitiveModifyCtrl",
                resolve: {
                    item: function() {
                        return item;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                modifyItem(result, item);
            });
        };
        $scope.addOrModify = function(item) {
            var templateUrl, controller, windowClass;
            if (item) {
                if (item.ISWORDSGROUP == '0') {
                    templateUrl = 'sensitive_add_tpl.html';
                    controller = 'sensitiveAddCtrl';
                    windowClass = "productManageMent-sensitive-add";
                } else {
                    templateUrl = 'sensitive_add_group_tpl.html';
                    controller = 'sensitiveAddGroupCtrl';
                    windowClass = "productManageMent-sensitive-add-group";
                }
            } else {
                templateUrl = 'sensitive_add_tpl.html';
                controller = 'sensitiveAddCtrl';
                windowClass = "productManageMent-sensitive-add";
            }

            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/" + templateUrl,
                windowClass: windowClass,
                backdrop: false,
                controller: controller,
                resolve: {
                    item: function() {
                        return item;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                !!item ? modifyItem(result, item) : addSensitive(result);
            });
        };
        //添加敏感词组
        $scope.addGroup = function(item) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/sensitive_add_group_tpl.html",
                windowClass: 'productManageMent-sensitive-add-group',
                backdrop: false,
                controller: "sensitiveAddGroupCtrl",
                resolve: {
                    item: function() {
                        return item;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                !!item ? modifyItem(result, item) : addSensitive(result);
            });
        };
        //添加敏感词方法1
        function addSensitive(result) {
            if (result.ISWORDSGROUP === 1) {
                var resultArray = result.sensitiveWord,
                    tempObject = [];
                for (var i = 0; i < resultArray.length; i++) {
                    var tempArray = resultArray[i].name;
                    tempObject.push(tempArray);
                }
                tempObject = tempObject.join(";");
            } else {
                var tempObject = result.sensitiveWord;
            }
            var params = {
                serviceid: "mlf_websiteconfig",
                methodname: 'saveNewSensitiveWords',
                ObjectId: '0',
                SensitiveWords: tempObject,
                SensitiveLevel: result.sensitiveLevel.value,
                SubstituteWords: result.substituteWord,
                ISWORDSGROUP: result.ISWORDSGROUP
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                modalDialog.alertType("添加敏感词成功", "", "success", false, function() {
                    requestData();
                });
            });
        }
        //删除敏感词
        $scope.deleteViews = function(item) {
            var nameNum, promptStr = '',
                content = "确定删除";
            if (!angular.isArray(item)) {
                promptStr += "【" + item.SENSITIVEWORDS + "】";
                content += promptStr + "敏感词?";
            } else {
                if (item.length <= 2) {
                    nameNum = item.length;
                } else {
                    nameNum = 2;
                }
                var SensitiveWN = item.length;
                for (var i = 0; i < nameNum; i++) {
                    promptStr += "【" + item[i].SENSITIVEWORDS + "】";
                }
                content += promptStr + "等" + SensitiveWN + "个敏感词?";
            }

            modalDialog.confirmModal('删除', content, function() {
                delectItems(item);
            });

        };
        //删除敏感词方法
        function delectItems(items) {
            var ids = angular.isArray(items) ? trsspliceString.spliceString(items, 'SENSITIVEWORDSID', ',') : items.SENSITIVEWORDSID;
            var params = {
                serviceid: "mlf_websiteconfig",
                methodname: "deleteSensitiveWords",
                SensitiveWordsIds: ids
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                modalDialog.alertType("删除成功", "", "success", false, function() {
                    requestData();
                })
            });
        }
        //批量添加弹窗
        $scope.batchAddViews = function() {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/sensitive_batch_add_tpl.html",
                windowClass: 'productManageMent-sensitive-batch-add',
                backdrop: false,
                controller: "sensitiveBatchAddCtrl"
            });
            return modalInstance.result.then(function(result) {
                batchAdd(result);
            });
        };
        //批量添加方法
        function batchAdd(result) {
            // var resultArray = result.sensitiveArray.split(/\n/);
            var resultArray = result.sensitiveArray;
            for (var i = 0; i < resultArray.length; i++) {
                var tempArray = resultArray[i].name;
                var tempObject = {
                    SensitiveWords: tempArray,
                    SubstituteWords: '',
                    SensitiveLevel: ''
                };
                resultArray[i] = tempObject;
            }
            var params = {
                serviceid: "mlf_websiteconfig",
                methodname: "batchSaveSensitiveWords",
                SensitiveWordss: JSON.stringify(resultArray),
                SensitiveLevel: result.sensitiveLevel.value
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function() {
                modalDialog.alertType("添加敏感词成功", "", "success", false, function() {
                    requestData();
                });
            });
        }
        //导入弹窗
        $scope.importViews = function(items) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/sensitive_import_tpl.html",
                windowClass: 'productManageMent-sensitive-import',
                backdrop: false,
                controller: "sensitiveImportCtrl"
            });
            return modalInstance.result.then(function(result) {
                // importFn(result);
                requestData();
            });
        };
        //导入方法
        function importFn(result) {
            var params = {
                serviceid: "mlf_websiteconfig",
                methodname: 'importSensitiveWords',
                ImportFile: result.name
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post", true).then(function(data) {
                modalDialog.alertType("导入敏感词成功", "", "success", false, function() {
                    requestData();
                });
            }, function(data) {
                modalDialog.multiReportsAlert(data, "");
                requestData();
            });
        }
        //修改弹窗
        // $scope.modifyViews = function(item) {
        //     var modalInstance = $modal.open({
        //         templateUrl: "./manageConfig/sysManageMent/sensitiveWord/template/sensitive_modify_tpl.html",
        //         windowClass: 'productManageMent-sensitive-modify',
        //         backdrop: false,
        //         controller: "sensitiveModifyCtrl",
        //         resolve: {
        //             item: function() {
        //                 return item;
        //             }
        //         }
        //     });
        //     return modalInstance.result.then(function(result) {
        //         modifyItem(result, item);
        //     });
        // };
        //修改方法
        function modifyItem(result, item) {
            if (result.ISWORDSGROUP === 1) {
                var resultArray = result.sensitiveWord,
                    tempObject = [];
                for (var i = 0; i < resultArray.length; i++) {
                    var tempArray = resultArray[i].name;
                    tempObject.push(tempArray);
                }
                tempObject = tempObject.join(";");
            } else {
                var tempObject = result.sensitiveWord;
            }
            var params = {
                serviceid: "mlf_websiteconfig",
                methodname: 'saveNewSensitiveWords',
                ObjectId: item.SENSITIVEWORDSID,
                SensitiveWords: tempObject,
                SensitiveLevel: result.sensitiveLevel.value,
                SubstituteWords: result.substituteWord,
                ISWORDSGROUP: result.ISWORDSGROUP
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                modalDialog.alertType("修改敏感词成功", "", "success", false, function() {
                    requestData();
                });
            });
        }

        //导出敏感词
        $scope.exportViews = function(items) {

            var ids = angular.isArray(items) ? trsspliceString.spliceString(items, 'SENSITIVEWORDSID', ',') : items.SENSITIVEWORDSID;
            var params = {
                serviceid: "mlf_exportword",
                methodname: 'ExportSensitiveWordsExcel',
                IsAll: false,
                SensitiveWordsIds: ids
            };
            //97d
            window.open(trsHttpService.getWCMRootUrl() + "?serviceid=mlf_exportword" + "&methodname=ExportSensitiveWordsExcel" + "&IsAll=false" + "&SensitiveWordsIds=" + ids);
        }

        //搜索
        $scope.search = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                $scope.params.SENSITIVEWORDS = $scope.keywords;
                requestData();
            }
        };
    }]);